
const ICONS = {
  success: 'mdi-check-circle-outline',
  error: 'mdi-alert',
  warning: 'mdi-alert-outline',
  info: 'mdi-information-outline'
};

export default {
  props: {
    type: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    }
  },
  computed: {
    icon () {
      return ICONS[this.type] || ICONS.info;
    }
  }
};
